import { useState, useEffect, useRef } from 'react';

/**
 * SupportTab - "Falar com um humano" dropdown with WhatsApp links
 */
export default function SupportTab() {
    const [isOpen, setIsOpen] = useState(false);
    const tabRef = useRef<HTMLDivElement>(null);

    // Close when clicking outside
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (tabRef.current && !tabRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    // Close on ESC key
    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        };

        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, []);

    return (
        <div
            id="supportTab"
            className={`support-tab ${isOpen ? 'active' : ''}`}
            ref={tabRef}
        >
            <div
                className="support-trigger"
                id="supportTrigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="support-trigger-icon">
                    <img
                        src="/images/human-support.webp"
                        alt="Suporte"
                    />
                </div>
                <span>Falar com um humano</span>
            </div>
            <div className="support-panel">
                <h3 className="support-panel-title">Fale Conosco</h3>

                <a
                    href="https://wa.me/5516997618739?text=Ol%C3%A1%2C%20vim%20do%20Or%C3%A1culo%20e%20preciso%20de%20uma%20ajudinha%20humana%20%F0%9F%98%84"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="support-option"
                >
                    <div className="support-option-icon">
                        <img
                            src="/images/suporte-alunos.webp"
                            alt="Suporte Alunos"
                        />
                    </div>
                    <div className="support-option-content">
                        <div className="support-option-label">Suporte Alunos</div>
                        <div className="support-option-desc">
                            Tire suas dúvidas com nossa equipe
                        </div>
                    </div>
                </a>

                <a
                    href="https://wa.me/5516997308097?text=Ol%C3%A1%2C%20vim%20do%20Or%C3%A1culo%20e%20gostaria%20de%20saber%20mais%20sobre%20as%20mentorias%20e%20programas%20Done%20For%20You%20de%20voc%C3%AAs%21"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="support-option"
                >
                    <div className="support-option-icon">
                        <img
                            src="/images/comercial.webp"
                            alt="Comercial"
                        />
                    </div>
                    <div className="support-option-content">
                        <div className="support-option-label">Comercial</div>
                        <div className="support-option-desc">
                            Saiba sobre mentorias e programas
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
}
